export default { sha: '353491464275b2d440574bd9dc5156e4700cecd2', buildNumber: 'undefined' }
